var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20278_7814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7623 10.1868C19.7623 9.36743 19.6958 8.76949 19.552 8.14941H10.1953V11.8477H15.6874C15.5768 12.7668 14.9788 14.1509 13.65 15.081L13.6314 15.2048L16.5898 17.4967L16.7948 17.5171C18.6771 15.7786 19.7623 13.2208 19.7623 10.1868Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1956 19.9312C12.8863 19.9312 15.1452 19.0453 16.7951 17.5173L13.6504 15.0812C12.8088 15.6681 11.6794 16.0777 10.1956 16.0777C7.5603 16.0777 5.32358 14.3393 4.52625 11.9365L4.40938 11.9464L1.3332 14.3271L1.29297 14.439C2.93175 17.6944 6.29793 19.9312 10.1956 19.9312Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52673 11.9363C4.31635 11.3163 4.19459 10.6518 4.19459 9.96534C4.19459 9.27878 4.31635 8.61443 4.51566 7.99435L4.51009 7.86229L1.39535 5.44336L1.29345 5.49183C0.618026 6.84275 0.230469 8.35977 0.230469 9.96534C0.230469 11.5709 0.618026 13.0879 1.29345 14.4388L4.52673 11.9363Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1956 3.85336C12.0669 3.85336 13.3292 4.66168 14.049 5.33718L16.8615 2.59107C15.1342 0.985496 12.8863 0 10.1956 0C6.29793 0 2.93175 2.23672 1.29297 5.49214L4.51518 7.99466C5.32358 5.59183 7.5603 3.85336 10.1956 3.85336Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20278_7814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.b050c704c8ab46781a30063b2ae43192.svg";
export { ForwardRef as ReactComponent };